import { IMAGES } from "@/constants/site";
import { Reveal } from "@/components/Reveal";

const STEPS = [
  {
    n: "01",
    title: "Book it",
    text: "Call, text, or send the quote form. Tell us what needs to go — photos help. You get a straight answer and a fast appointment window.",
    img: IMAGES.teamTruck,
  },
  {
    n: "02",
    title: "We haul it",
    text: "We show up on time, give you a firm upfront price before we start, and do every bit of the lifting, loading, and hauling. You point, we carry.",
    img: IMAGES.dumpTruck,
  },
  {
    n: "03",
    title: "Start fresh",
    text: "We sweep up before we leave and donate or recycle everything we can. Your space is yours again — the same day, in most cases.",
    img: IMAGES.cleanRoom,
  },
];

export const HowItWorks = () => (
  <section data-testid="how-it-works-section" className="border-y border-seam bg-coal">
    <div className="mx-auto max-w-7xl px-6 py-24 md:px-10 md:py-32">
      <Reveal>
        <p className="mb-4 text-xs font-bold uppercase tracking-[0.35em] text-acid">The leap, step by step</p>
        <h2 className="mb-20 font-display text-4xl font-black italic uppercase leading-none tracking-tighter sm:text-5xl lg:text-[5vw]">
          Three steps. <span className="text-outline">Zero lifting.</span>
        </h2>
      </Reveal>

      <div className="flex flex-col gap-24 md:gap-32">
        {STEPS.map((step, i) => (
          <div
            key={step.n}
            className={`grid items-center gap-10 md:grid-cols-12 ${i % 2 === 1 ? "md:[direction:rtl]" : ""}`}
          >
            <Reveal className="relative md:col-span-7 md:[direction:ltr]">
              <span
                aria-hidden="true"
                className="text-outline-acid pointer-events-none absolute -top-16 left-0 z-0 font-display text-[9rem] font-black italic leading-none md:-top-24 md:text-[13rem]"
              >
                {step.n}
              </span>
              <div className="relative z-10 pt-20 md:pt-32">
                <h3 className="font-display text-3xl font-black italic uppercase tracking-tight sm:text-4xl">
                  {step.title}
                </h3>
                <p className="mt-4 max-w-lg text-base leading-relaxed text-zinc-400 md:text-lg">{step.text}</p>
              </div>
            </Reveal>
            <Reveal delay={0.15} className="md:col-span-5 md:[direction:ltr]">
              <div className="group overflow-hidden border border-seam [clip-path:polygon(0_0,100%_0,100%_88%,92%_100%,0_100%)]">
                <img
                  src={step.img}
                  alt={step.title}
                  className="aspect-[4/3] w-full object-cover grayscale transition-all duration-700 group-hover:scale-105 group-hover:grayscale-0"
                  loading="lazy"
                />
              </div>
            </Reveal>
          </div>
        ))}
      </div>
    </div>
  </section>
);
